import { makeStyles } from 'e100-react-components';

import { FAVOURITE_STATIONS_MODAL_Z_INDEX } from 'common/constants';

export const useStyles = makeStyles(({ spacing }) => ({
  contentRoot: {
    padding: 0 
  },
  container: {
    height: `calc(100% - ${spacing(6.25)}px)`,
    width: '100%',
    marginLeft: 0,
    marginRight: 0,
    overflow: 'hidden'
  },
  contentContainer: {
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden'
  },
  dialogRoot: {
    // @ts-ignore
    zIndex: `${FAVOURITE_STATIONS_MODAL_Z_INDEX} !important` as number
  }
}));